export { default } from './UnscoredCategoryPageProvidersSection'
